<template>
  <span
    class="inline-block max-w-full truncate"
    :title="fullTitle"
  >
    {{ label }}
  </span>
</template>

<script setup>
/* eslint-env vue/setup-compiler-macros */
import { computed } from 'vue'

const props = defineProps({
  items: { type: Array, default: () => [] },
  included: { type: Boolean, default: true }
})

const fullTitle = computed(() =>
  (props.items || [])
    .map(x => (typeof x === 'object' ? (x.name || x.uuid) : x))
    .join(', ')
)

const label = computed(() => {
  if (!props.included) return 'Excluded'
  if (!props.items?.length) return 'All'
  const shown = props.items.slice(0, 3).map(x => (typeof x === 'object' ? (x.name || x.uuid) : x))
  const more = props.items.length - shown.length
  return more > 0 ? `${shown.join(', ')}, +${more} more` : shown.join(', ')
})
</script>